import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=b81cb446&scoped=true"
import script from "./BusinessCard.vue?vue&type=script&lang=js"
export * from "./BusinessCard.vue?vue&type=script&lang=js"
import style0 from "./BusinessCard.vue?vue&type=style&index=0&id=b81cb446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81cb446",
  null
  
)

export default component.exports